var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"techerDivDisplay"},[_c('title-widge',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle}}),_c('div',[_c('common-techer-display-widge',{staticClass:"teacher_desc",attrs:{"imgs":_vm.items}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }